import React, {Fragment} from "react";
import {Link, Route} from "react-router-dom";
import Image from "react-image-fallback";

import {isEmpty, objectFindKey} from "../../lib/tools";
import {Button, Footer, InfinityScroll, LoadingSpinner} from "../common/common";
import {SwapTransitionGroup, TransitionSwitch} from "../animations";
import {reduxWrapper} from "../../globalState";
import {BannerHeader} from "../structure";
import {getImage} from "../../lib/api";
// Icons
import Arrow from "../../resources/icons/longArrow_White.svg";
// Images
import placeholderImage from "../../resources/images/placeholder.png";
import bannerImg from "../../resources/images/forsideBanner.jpg";

const ArticleView = (props) => (
	<TransitionSwitch component={SwapTransitionGroup} animation="popIn" relative>
		<Route path="/oversigt" render={() => (
			<TransitionSwitch component={SwapTransitionGroup} animation="popIn" relative>
				<Route path="/:section" render={({match: {params: {section}}}) =>
					<ArticleLandingView section={section}/>
				}/>
				<Route render={() => <ArticleLandingView/>}/>
			</TransitionSwitch>
		)}/>
		<Route path="/:identifier" render={({match: {params: {identifier}}}) =>
			<SingleArticleView identifier={identifier}/>}
		/>
		<Route render={() => <ArticleLandingView/>}/>
	</TransitionSwitch>
);

//Temp for article

export class ArticleLandingViewRender extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			articles: [],
		};
		
		this.loadMore = (page, limit) => new Promise((resolve, reject) =>
			this.props.apiCall("GET", "/articles", data => {
				this.setState(prev => ({articles: [...prev.articles, ...data]}));
				resolve(data ? data.length : 0);
			}, {
				limitOffset: (page - 1) * limit,
				limit,
				sectionId: this.props.section && objectFindKey(this.props.sections, x => x.vanity.toLowerCase() === this.props.section.toLowerCase())
			})
		);
	}
	
	render() {
		if (isEmpty(this.props.sections)) {
			return (
				<article className="maxWidth">
					<section className="landingAricles">
						<LoadingSpinner/>
					</section>
				</article>
			);
		}
		
		return (
			<article className="maxWidth">
				<section className="landingAricles">
					<InfinityScroll loadMore={this.loadMore} loadCount={8} className="lsArticlesList">
						{this.state.articles.map((x, i) => (
							<ArticleItem key={i} {...x} category={this.props.sections[x.sectionId].title}/>
						))}
					</InfinityScroll>
				</section>
			</article>
		)
	}
}

const ArticleLandingView = reduxWrapper("getApiCall", "loadSections")(ArticleLandingViewRender);

export const ArticleItem = ({title, identifier, image, category, preview}) => (
	<Link to={`/inspiration/${identifier}`} className="lsArticle" target="_blank">
		<div className="lsArticleImg">
			<Image src={getImage(image)} alt="temp" fallbackImage={placeholderImage} initialImage={<LoadingSpinner/>}/>
		</div>
		<div className="lsArticleInfo">
			<span>{category}</span>
			<h3>{title}</h3>
			<p>{preview}</p>
			<Button className="btnWhite" blank="true">LÆS MERE</Button>
		</div>
	</Link>
);

class SingleArticleViewRender extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			title: null,
			content: ""
		}
	}
	
	componentWillMount() {
		this.setState({loading: true});
		this.props.apiCall("GET", "/article",
			data => this.setState({title: data.title, content: data.content, loading: false}),
			{identifier: this.props.identifier})
	}
	
	render() {
		return (
			<Fragment>
				<BannerHeader bgImage={bannerImg} className="articleBanner">
					<div className="articleBannerContent">
						<h1 className="headline">Din fest starter her</h1>
						<p>
							Ved at samle alt til fester ét sted kan du nemt og hurtigt få hele festen leveret lige til døren.
						</p>
						<div className="frontPageBtns">
							<Link className="fpBtn toDiy ga-toBygSelvArtickle" to={"/minfest"}>
								<span>Skræddersyet</span>
								<span>Byg selv</span>
								<img src={Arrow} alt="Byg selv"/>
							</Link>
							<Link className="fpBtn toBundles ga-toBundlesArtickle" to={"/pakker"}>
								<span>Færdige koncepter</span>
								<span>Grydeklare fester</span>
								<img src={Arrow} alt="Til pakker"/>
							</Link>
						</div>
					</div>
				</BannerHeader>
				<article className="articleContainer maxWidth">
					<h1 className="title-l">{this.state.title}</h1>
					<div className="a-body" dangerouslySetInnerHTML={{__html: this.state.content}}/>
				</article>
				<Footer key="footer"/>
			</Fragment>
		);
	}
}

export const SingleArticleView = reduxWrapper("getApiCall")(SingleArticleViewRender);

export default ArticleView;


// WEBPACK FOOTER //
// ./src/components/views/articleView.js